// import React, { useState, useEffect } from 'react';
// import './App.css';
// import traducciones from './traducciones';

// const LiniaVerdaForm = () => {
//   const [language, setLanguage] = useState('ca');
//   const [formData, setFormData] = useState({
//     consultant: '',
//     age: '',
//     location: '',
//     locationId:'',
//     email: '',
//     query: '',
//     acceptPrivacy: false,
//     acceptProfessionals: false
//   });

//   const [dataForm, setDataForm] = useState(null);
//   // const [loadingDataForm, setLoadingDataForm] = useState(true);
//   // const [errorDataForm, setErrorDataForm] = useState(null);

//   // const ageRanges = dataForm.content;

//   useEffect(() => {
//     const fetchDataForm = async () => {
//       try {
//         const response = await fetch(
//           "/api/linia-verda/data-form"
//         );
  
//         if (!response.ok) {
//           throw new Error("Error al obtener data_form");
//         }
  
//         const result = await response.json();
//         setDataForm(result.data);
//         console.log(result.data)
//       } catch (error) {
//         console.error("❌ Error cargando data_form:", error);
//       }
//     };

//     fetchDataForm();
//   }, []);

//   const isFormValid = () => {
//     return (
//       formData.consultant &&
//       formData.age &&
//       formData.location &&
//       formData.email &&
//       formData.query &&
//       formData.acceptPrivacy &&
//       formData.acceptProfessionals
//     );
//   };

//   const [selectedLocationId, setSelectedLocationId] = useState('');

//   const handleLocationBlur = () => {
//     const match = dataForm?.localitzacio?.find(
//       loc => `${loc.cod_postal} – ${loc.des_municipi}` === formData.location
//     );
  
//     if (!match) {
//       setFormData(prev => ({ ...prev, location: '' }));
//       setSelectedLocationId('');
//       alert("Selecciona un código postal y municipio de la lista");
//     } else {
//       setSelectedLocationId(match.localitzacio_id);
//       formData.locationId = selectedLocationId
//     }
//   };
  


//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: type === 'checkbox' ? checked : value
//     }));
//   };

//   const handleSubmit = async () => {
//     const t = traducciones[language].alerts;

//     if (!formData.consultant) {
//       alert(t.selectConsultant);
//       return;
//     }
//     if (!formData.age || !formData.location || !formData.email || !formData.query) {
//       alert(t.fillAllFields);
//       return;
//     }
//     if (!formData.acceptPrivacy) {
//       alert(t.acceptPrivacy);
//       return;
//     }

//     try {
//       const response = await fetch('/api/linia-verda/consulta', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify(formData)
//       });

//       if (response.ok) {
//         alert(t.success);
//         setFormData({
//           consultant: '',
//           age: '',
//           location: '',
//           email: '',
//           query: '',
//           acceptPrivacy: false,
//           acceptProfessionals: false
//         });
//       } else {
//         throw new Error('Error');
//       }
//     } catch (error) {
//       console.error(error);
//       alert(t.error);
//     }
//   };


//   const t = traducciones[language];

//   return (
//     <div>
//       <header className="header-bar">
//         <div className="header-left"></div>
//         <div className="header-right">
//           <select
//             className="language-selector"
//             value={language}
//             onChange={(e) => setLanguage(e.target.value)}
//           >
//             <option value="ca">Català</option>
//             <option value="es">Castellano</option>
//           </select>
//         </div>
//       </header>

//       <div className="container">
//         <div className="header">
//           <img src="/liniaoberta_web_img.png" alt="Logo" className="header-logo" />
//         </div>

//         <p className="obligatory-text">
//           {t.obligatory.split('*')[0]}<span className="red">*</span>{t.obligatory.split('*')[1]}
//         </p>

//         <hr className="separator" />

//         <p className="description">{t.description}</p>

//         <div className="form-wrapper">
//           {/* CONSULTANT */}
//           <div className="form-section">
//             <label className="label">{t.perQui} <span className="red">*</span></label>
//             <div className="radio-grid">
//               {dataForm?.parentiu?.map(item => {
//                 const label =
//                   language === 'ca'
//                     ? item.descripcio_parentiu
//                     : item.descripcio_parentiu_esp;

//                 return (
//                   <label key={item.parentiu_id} className="radio-label">
//                     <input
//                       type="radio"
//                       name="consultant"
//                       value={item.parentiu_id}
//                       checked={formData.consultant === String(item.parentiu_id)}
//                       onChange={handleInputChange}
//                       className="radio-input"
//                     />
//                     <span>{label}</span>
//                   </label>
//                 );
//               })}
//             </div>

//           </div>

//           {/* EDAT */}
//           <div className="form-section">
//             <div className="input-grid">
//               <div>
//                 <label className="label">
//                   {t.age}<span className="red">*</span>
//                 </label>

//                 <select
//                   name="age"
//                   value={formData.age}
//                   onChange={handleInputChange}
//                   className="input"
//                 >
//                   <option value="">{t.agePlaceholder}</option>

//                   {dataForm?.trams_edat?.map(range => {
//                     const label =
//                       language === 'ca'
//                         ? range.descripcio_trams_edat
//                         : range.descripcio_trams_edat_esp;

//                     return (
//                       <option
//                         key={range.trams_edat_id}
//                         value={range.trams_edat_id}
//                       >
//                         {label}
//                       </option>
//                     );
//                   })}
//                 </select>

//               </div>
//               <div>
//                 {/* <label className="label">{t.location}<span className="red">*</span></label>
//                 <input type="text" name="location" value={formData.location} onChange={handleInputChange} className="input" /> */}
//                 <div>
//                   <div>
//                     <label className="label">
//                       {t.location}<span className="red">*</span>
//                     </label>

//                     <input
//                       list="localitzacions"
//                       name="location"
//                       value={formData.location}
//                       onChange={handleInputChange}
//                       placeholder={t.locationPlaceholder}
//                       className="input"
//                       onBlur={handleLocationBlur}
//                     />

//                     <datalist id="localitzacions">
//                       {dataForm?.localitzacio?.map(loc => (
//                         <option
//                           key={loc.localitzacio_id}
//                           value={`${loc.cod_postal} – ${loc.des_municipi}`}
//                         />
//                       ))}
//                     </datalist>
//                   </div>

//                 </div>

//               </div>

//               <div>
//                 <label className="label">{t.email}<span className="red">*</span></label>
//                 <input type="email" name="email" value={formData.email} onChange={handleInputChange} className="input" />
//               </div>
//             </div>
//           </div>

//           {/* CONSULTA */}
//           <div className="form-section">
//             <label className="label">{t.query}<span className="red">*</span></label>
//             <textarea name="query" value={formData.query} onChange={handleInputChange} rows={6} className="textarea" />
//           </div>

//           {/* CHECKBOXES */}
//           <div className="form-section">
//             <div className="checkbox-container">
//               <label className="checkbox-label">
//                 <input type="checkbox" name="acceptPrivacy" checked={formData.acceptPrivacy} onChange={handleInputChange} className="checkbox" />
//                 <span className="checkbox-text"><span className="red">*</span> {t.acceptPrivacy}</span>
//               </label>

//               <label className="checkbox-label">
//                 <input type="checkbox" name="acceptProfessionals" checked={formData.acceptProfessionals} onChange={handleInputChange} className="checkbox" />
//                 <span className="checkbox-text"><span className="red">*</span> {t.acceptProfessionals}</span>
//               </label>
//             </div>
//           </div>

//           {/* SUBMIT */}
//           <div className="button-container">
//             <button onClick={handleSubmit} className="button" disabled={!isFormValid()}>{t.submit}</button>
//           </div>

//         </div>

//         {/* INFORMACIÓ SOBRE PROTECCIÓ DE DADES */}
//         <div className="data-table-container">
//           <div className="data-table-container">
//             <h3 className="data-table-title">{t.dataTableTitle}</h3>
//             <table className="data-table">
//               <tbody>
//                 <tr>
//                   <th>{t.dataTable.responsable}</th>
//                   <td>{t.dataTable.responsableValor}</td>
//                 </tr>
//                 <tr>
//                   <th>{t.dataTable.finalitat}</th>
//                   <td>{t.dataTable.finalitatValor}</td>
//                 </tr>
//                 <tr>
//                   <th>{t.dataTable.legitimacio}</th>
//                   <td>{t.dataTable.legitimacioValor}</td>
//                 </tr>
//                 <tr>
//                   <th>{t.dataTable.destinataris}</th>
//                   <td>{t.dataTable.destinatarisValor}</td>
//                 </tr>
//                 <tr>
//                   <th>{t.dataTable.drets}</th>
//                   <td>
//                     <ul className="drets-list">
//                       <li>
//                         <strong>{t.dataTable.dretsAccesTitol}</strong>: {t.dataTable.dretsAccesText}
//                       </li>
//                       <li>
//                         <strong>{t.dataTable.dretsRectificacioTitol}</strong>: {t.dataTable.dretsRectificacioText}
//                       </li>
//                       <li>
//                         <strong>{t.dataTable.dretsSupressioTitol}</strong>: {t.dataTable.dretsSupressioText}
//                       </li>
//                       <li>
//                         <strong>{t.dataTable.dretsLimitacioTitol}</strong>: {t.dataTable.dretsLimitacioText}
//                       </li>
//                       <li>
//                         <strong>{t.dataTable.dretsOposicioTitol}</strong>: {t.dataTable.dretsOposicioText}
//                       </li>
//                       <li>
//                         <strong>{t.dataTable.dretsPortabilitatTitol}</strong>: {t.dataTable.dretsPortabilitatText}
//                       </li>
//                       <li>
//                         <strong>{t.dataTable.dretsRetirarConsentimentTitol}</strong>: {t.dataTable.dretsRetirarConsentimentText}
//                       </li>
//                     </ul>
//                   </td>
//                 </tr>
//                 <tr>
//                   <th>{t.dataTable.exerciciDrets}</th>
//                   <td>
//                     <p>{t.dataTable.exerciciDretsText1}</p>
//                     <p>{t.dataTable.exerciciDretsText2}</p>
//                   </td>
//                 </tr>
//                 <tr>
//                   <th>{t.dataTable.infoAddicional}</th>
//                   <td>
//                     {t.dataTable.infoAddicionalValor}{" "}
//                     <a href={t.dataTable.infoAddicionalLink} target="_blank" rel="noopener noreferrer">
//                       www.ipss-online.org
//                     </a>.
//                   </td>
//                 </tr>
//               </tbody>
//             </table>
//           </div>

//         </div>
//       </div>

//       <footer className="footer-bar">
//         <div className='footer-gestiona'>
//           <p>{t.dataTable.gestiona}</p>
//           <div className="footer-icons">
//             <div className="footer-icon-placeholder">
//               <img src="/logo_ipss.png" alt="Logo IPSS" className="ipss-logo" />
//             </div>
//           </div>
//         </div>
//         <div className='footer-colaboracio'>
//           <p>{t.dataTable.colaboracio}</p>
//           <div className="footer-icons">
//             <div className="footer-icon-placeholder">
//               <img src="/departament_drets_socials.jpg" alt="Logo Drets Socials" className="departament-logo" />
//               <img src="/departament_salut_logo.jpg" alt="Logo Salut" className="departament-logo-salut" />
//             </div>
//           </div>
//         </div>
//       </footer>
//     </div>
//   );
// };

// export default LiniaVerdaForm;

import React, { useState, useEffect } from 'react';
import './App.css';
import traducciones from './traducciones';
import Select from 'react-select';

const LiniaVerdaForm = () => {
  const [language, setLanguage] = useState('ca');
  const [formData, setFormData] = useState({
    consultant: '',
    age: '',
    // location: '',
    locationId:'',
    email: '',
    query: '',
    acceptPrivacy: false,
    acceptProfessionals: false
  });

  const [dataForm, setDataForm] = useState(null);
  // const [loadingDataForm, setLoadingDataForm] = useState(true);
  // const [errorDataForm, setErrorDataForm] = useState(null);

  // const ageRanges = dataForm.content;

  useEffect(() => {
    const fetchDataForm = async () => {
      try {
        const response = await fetch(
          "/api/linia-verda/data-form"
        );
  
        if (!response.ok) {
          throw new Error("Error al obtener data_form");
        }
  
        const result = await response.json();
        setDataForm(result.data);
        console.log(result.data)
      } catch (error) {
        console.error("❌ Error cargando data_form:", error);
      }
    };

    fetchDataForm();
  }, []);

  const isFormValid = () => {
    return (
      formData.consultant &&
      formData.age &&
      formData.locationId &&
      formData.email &&
      formData.query &&
      formData.acceptPrivacy &&
      formData.acceptProfessionals
    );
  };

  const [selectedLocationId, setSelectedLocationId] = useState('');

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: type === 'checkbox' ? checked : value
    }));
  };

  const handleSubmit = async () => {
    const t = traducciones[language].alerts;

    if (!formData.consultant) {
      alert(t.selectConsultant);
      return;
    }
    if (!formData.age || !formData.locationId || !formData.email || !formData.query) {
      alert(t.fillAllFields);
      return;
    }
    if (!formData.acceptPrivacy) {
      alert(t.acceptPrivacy);
      return;
    }

    try {
      const response = await fetch('/api/linia-verda/consulta', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData)
      });

      if (response.ok) {
        alert(t.success);
        setFormData({
          consultant: '',
          age: '',
          locationId: '',
          email: '',
          query: '',
          acceptPrivacy: false,
          acceptProfessionals: false
        });
      } else {
        throw new Error('Error');
      }
    } catch (error) {
      console.error(error);
      alert(t.error);
    }
  };

  const locationOptions = dataForm?.localitzacio?.map(loc => ({
    value: loc.ubicacio_geografica_id, // lo que quieres guardar
    label: `${loc.cod_postal} – ${loc.des_municipi}` // lo que ve el usuario
  })) || [];

  const t = traducciones[language];

  return (
    <div>
      <header className="header-bar">
        <div className="header-left"></div>
        <div className="header-right">
          <select
            className="language-selector"
            value={language}
            onChange={(e) => setLanguage(e.target.value)}
          >
            <option value="ca">Català</option>
            <option value="es">Castellano</option>
          </select>
        </div>
      </header>

      <div className="container">
        <div className="header">
          <img src="/liniaoberta_web_img.png" alt="Logo" className="header-logo" />
        </div>

        <p className="obligatory-text">
          {t.obligatory.split('*')[0]}<span className="red">*</span>{t.obligatory.split('*')[1]}
        </p>

        <hr className="separator" />

        <p className="description">{t.description}</p>

        <div className="form-wrapper">
          {/* CONSULTANT */}
          <div className="form-section">
            <label className="label">{t.perQui} <span className="red">*</span></label>
            <div className="radio-grid">
              {dataForm?.parentiu?.map(item => {
                const label =
                  language === 'ca'
                    ? item.descripcio_parentiu
                    : item.descripcio_parentiu_esp;

                return (
                  <label key={item.parentiu_id} className="radio-label">
                    <input
                      type="radio"
                      name="consultant"
                      value={item.parentiu_web_id}
                      checked={formData.consultant === String(item.parentiu_web_id)}
                      onChange={handleInputChange}
                      className="radio-input"
                    />
                    <span>{label}</span>
                  </label>
                );
              })}
            </div>

          </div>

          {/* EDAT */}
          <div className="form-section">
            <div className="input-grid">
              <div>
                <label className="label">
                  {t.age}<span className="red">*</span>
                </label>

                <select
                  name="age"
                  value={formData.age}
                  onChange={handleInputChange}
                  className="input"
                >
                  <option value="uno">{t.agePlaceholder}</option>

                  {dataForm?.trams_edat?.map(range => {
                    const label =
                      language === 'ca'
                        ? range.descripcio_trams_edat
                        : range.descripcio_trams_edat_esp;

                    return (
                      <option
                        key={range.trams_edat_id}
                        value={range.trams_edat_id}
                      >
                        {label}
                      </option>
                    );
                  })}
                </select>

              </div>
              <div>
  <label className="label">
    {t.location}<span className="red">*</span>
  </label>

  <Select
  options={locationOptions}
  value={selectedLocationId} // el objeto completo
  onChange={option => 
    {setSelectedLocationId(option)
    console.log(option.value)
    formData.locationId = option.value
  }
  }
  placeholder={t.locationPlaceholder}
  isSearchable
/>


</div>


              <div>
                <label className="label">{t.email}<span className="red">*</span></label>
                <input type="email" name="email" value={formData.email} onChange={handleInputChange} className="input" />
              </div>
            </div>
          </div>

          {/* CONSULTA */}
          <div className="form-section">
            <label className="label">{t.query}<span className="red">*</span></label>
            <textarea name="query" value={formData.query} onChange={handleInputChange} rows={6} className="textarea" />
          </div>

          {/* CHECKBOXES */}
          <div className="form-section">
            <div className="checkbox-container">
              <label className="checkbox-label">
                <input type="checkbox" name="acceptPrivacy" checked={formData.acceptPrivacy} onChange={handleInputChange} className="checkbox" />
                <span className="checkbox-text"><span className="red">*</span> {t.acceptPrivacy}</span>
              </label>

              <label className="checkbox-label">
                <input type="checkbox" name="acceptProfessionals" checked={formData.acceptProfessionals} onChange={handleInputChange} className="checkbox" />
                <span className="checkbox-text"><span className="red">*</span> {t.acceptProfessionals}</span>
              </label>
            </div>
          </div>

          {/* SUBMIT */}
          <div className="button-container">
            <button onClick={handleSubmit} className="button" disabled={!isFormValid()}>{t.submit}</button>
          </div>

        </div>

        {/* INFORMACIÓ SOBRE PROTECCIÓ DE DADES */}
        <div className="data-table-container">
          <div className="data-table-container">
            <h3 className="data-table-title">{t.dataTableTitle}</h3>
            <table className="data-table">
              <tbody>
                <tr>
                  <th>{t.dataTable.responsable}</th>
                  <td>{t.dataTable.responsableValor}</td>
                </tr>
                <tr>
                  <th>{t.dataTable.finalitat}</th>
                  <td>{t.dataTable.finalitatValor}</td>
                </tr>
                <tr>
                  <th>{t.dataTable.legitimacio}</th>
                  <td>{t.dataTable.legitimacioValor}</td>
                </tr>
                <tr>
                  <th>{t.dataTable.destinataris}</th>
                  <td>{t.dataTable.destinatarisValor}</td>
                </tr>
                <tr>
                  <th>{t.dataTable.drets}</th>
                  <td>
                    <ul className="drets-list">
                      <li>
                        <strong>{t.dataTable.dretsAccesTitol}</strong>: {t.dataTable.dretsAccesText}
                      </li>
                      <li>
                        <strong>{t.dataTable.dretsRectificacioTitol}</strong>: {t.dataTable.dretsRectificacioText}
                      </li>
                      <li>
                        <strong>{t.dataTable.dretsSupressioTitol}</strong>: {t.dataTable.dretsSupressioText}
                      </li>
                      <li>
                        <strong>{t.dataTable.dretsLimitacioTitol}</strong>: {t.dataTable.dretsLimitacioText}
                      </li>
                      <li>
                        <strong>{t.dataTable.dretsOposicioTitol}</strong>: {t.dataTable.dretsOposicioText}
                      </li>
                      <li>
                        <strong>{t.dataTable.dretsPortabilitatTitol}</strong>: {t.dataTable.dretsPortabilitatText}
                      </li>
                      <li>
                        <strong>{t.dataTable.dretsRetirarConsentimentTitol}</strong>: {t.dataTable.dretsRetirarConsentimentText}
                      </li>
                    </ul>
                  </td>
                </tr>
                <tr>
                  <th>{t.dataTable.exerciciDrets}</th>
                  <td>
                    <p>{t.dataTable.exerciciDretsText1}</p>
                    <p>{t.dataTable.exerciciDretsText2}</p>
                  </td>
                </tr>
                <tr>
                  <th>{t.dataTable.infoAddicional}</th>
                  <td>
                    {t.dataTable.infoAddicionalValor}{" "}
                    <a href={t.dataTable.infoAddicionalLink} target="_blank" rel="noopener noreferrer">
                      www.ipss-online.org
                    </a>.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

        </div>
      </div>

      <footer className="footer-bar">
        <div className='footer-gestiona'>
          <p>{t.dataTable.gestiona}</p>
          <div className="footer-icons">
            <div className="footer-icon-placeholder">
              <img src="/logo_ipss.png" alt="Logo IPSS" className="ipss-logo" />
            </div>
          </div>
        </div>
        <div className='footer-colaboracio'>
          <p>{t.dataTable.colaboracio}</p>
          <div className="footer-icons">
            <div className="footer-icon-placeholder">
              <img src="/departament_drets_socials.jpg" alt="Logo Drets Socials" className="departament-logo" />
              <img src="/departament_salut_logo.jpg" alt="Logo Salut" className="departament-logo-salut" />
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default LiniaVerdaForm;
